import { Col, mediaQueries, size } from '@everlywell/leaves';
import styled from 'styled-components';

export const ProductGridCol = styled(Col)`
  display: grid;
  grid-template-columns: auto;
  row-gap: ${size.xl2}px;
  column-gap: 1rem;
  align-items: stretch;
  padding-bottom: ${size.xl2}px;

  ${mediaQueries.forTabletVerticalUp} {
    grid-template-columns: repeat(2, 1fr);
  }

  ${mediaQueries.forTabletHorizontalUp} {
    grid-template-columns: repeat(3, 1fr);
    column-gap: 2rem;
  }

  > div {
    border-radius: ${size.xs1}px;
    overflow: hidden;

    a {
      border-radius: ${size.xs1}px;
    }
  }
`;
